<template>
  <section v-if="timer" class="time-panel" :class="`is-${timer.status}`">
    <div class="time-copy">
      <small>Tiempo de la cuenta</small>
      <strong>{{ formattedRemaining }}</strong>
      <span>{{ statusLabel }} · {{ purchasedLabel }} contratado(s)</span>
    </div>
    <div class="time-actions">
      <button v-if="timer.status === 'pending'" type="button" class="time-button primary" @click="$emit('control', 'start')">Iniciar tiempo</button>
      <button v-if="timer.status === 'paused'" type="button" class="time-button primary" @click="$emit('control', 'resume')">Reanudar</button>
      <button v-if="timer.status === 'running'" type="button" class="time-button" @click="$emit('control', 'pause')">Pausar</button>
      <span v-if="timer.status === 'finished'" class="finished-label">Tiempo terminado</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PosTimePanel',
  props: {
    timer: { type: Object, default: null },
  },
  emits: ['control'],
  data() {
    return {
      baselineRemaining: 0,
      baselineAt: Date.now(),
      nowTick: Date.now(),
      intervalId: null,
    };
  },
  computed: {
    remainingSeconds() {
      if (!this.timer) return 0;
      const elapsed = this.timer.status === 'running'
        ? Math.floor((this.nowTick - this.baselineAt) / 1000)
        : 0;
      return Math.max(0, this.baselineRemaining - elapsed);
    },
    formattedRemaining() {
      const seconds = this.remainingSeconds;
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainder = seconds % 60;
      return [hours, minutes, remainder].map((value) => String(value).padStart(2, '0')).join(':');
    },
    purchasedLabel() {
      const total = Number(this.timer?.purchased_seconds || 0);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      if (hours && minutes) return `${hours} h ${minutes} min`;
      if (hours) return `${hours} h`;
      return `${minutes} min`;
    },
    statusLabel() {
      return {
        pending: 'Sin iniciar',
        running: 'En curso',
        paused: 'Pausado',
        finished: 'Finalizado',
      }[this.timer?.status] || 'Sin tiempo';
    },
  },
  watch: {
    timer: {
      deep: true,
      immediate: true,
      handler(value) {
        this.baselineRemaining = Math.max(0, Number(value?.remaining_seconds || 0));
        this.baselineAt = Date.now();
        this.nowTick = Date.now();
      },
    },
  },
  mounted() {
    this.intervalId = window.setInterval(() => { this.nowTick = Date.now(); }, 1000);
  },
  beforeUnmount() {
    if (this.intervalId) window.clearInterval(this.intervalId);
  },
};
</script>

<style scoped>
.time-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .8rem;
  padding: .85rem;
  border: 1px solid rgba(255, 255, 255, .18);
  border-radius: 18px;
  background:
    radial-gradient(circle at 12% 0%, rgba(244, 162, 97, .28), transparent 9rem),
    linear-gradient(145deg, rgba(21, 39, 68, .97), rgba(11, 23, 42, .95));
  color: #fff;
  box-shadow: 0 16px 38px rgba(15, 23, 42, .18);
}
.time-panel.is-running { border-color: rgba(72, 207, 173, .45); }
.time-panel.is-finished { border-color: rgba(255, 111, 97, .48); }
.time-copy { display: grid; gap: .12rem; min-width: 0; }
.time-copy small, .time-copy span { color: rgba(255, 255, 255, .68); font-weight: 800; }
.time-copy strong { font-size: clamp(1.35rem, 3vw, 2rem); line-height: 1; letter-spacing: .06em; font-variant-numeric: tabular-nums; }
.time-actions { display: flex; gap: .45rem; align-items: center; }
.time-button, .finished-label {
  border: 1px solid rgba(255, 255, 255, .2);
  border-radius: 999px;
  padding: .62rem .8rem;
  background: rgba(255, 255, 255, .1);
  color: #fff;
  font-weight: 900;
}
.time-button { cursor: pointer; }
.time-button.primary { background: #f4a261; border-color: #f4a261; color: #14213d; }
.finished-label { color: #ffd1cc; }
@media (max-width: 560px) {
  .time-panel { align-items: stretch; flex-direction: column; }
  .time-button { width: 100%; }
}
</style>
